import { InputNumber } from 'antd';

function FileProps(props) {
    const { values, onChange } = props;
    return (
        <div className='col-12'>
            <div className='row mb-2'>
            <small className="mt-sm-auto mt-2 order-sm-1 order-0">**Sono ammessi solo i seguenti tipi di file: jpeg, png. Massimo 24MB per file</small>
            </div>
        </div>
    )
}

export default FileProps